import clsx from 'clsx'
import {KTCard, KTCardBody} from '../../../../_metronic/helpers'
import {useLazyQuery} from '@apollo/client'
import {GET_ALL_USERS_BASIC} from '../../gql/queries/usersQuery'
import {IResAllUsers} from '../../types/users'
import {useEffect, useState} from 'react'
import {toast} from 'react-toastify'
import {Button, Spinner} from 'react-bootstrap'
import {useDisclourse} from '../../hooks/useDisclourse'
import {ModalAddMember} from './components/ModalAddMember'
import {IInfoUser} from './typeMembers'
import {useSearchParams} from 'react-router-dom'
import {useIntl} from 'react-intl'
import {getColorMember} from '../../helpers'
import {PhoneProviderActions} from '../../components/telephony/PhoneProviderActions'
import {MEMBER_MESSAGES as M, NOT_RECORDED} from './memberMessages'

export const MembersPage = () => {
  const intl = useIntl()
  const [gqlGetMembers, {data, loading, error, refetch}] = useLazyQuery<IResAllUsers>(
    GET_ALL_USERS_BASIC,
    {
      fetchPolicy: 'no-cache',
    }
  )
  const [search] = useSearchParams()

  const p = search.get('open')

  const {isOpen, onClose, onOpen} = useDisclourse()
  const [infoEdit, setInfoEdit] = useState<null | IInfoUser>(null)

  useEffect(() => {
    gqlGetMembers()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (error) {
      toast.error(intl.formatMessage(M.errorWithMessage, {message: error.message}))
    }
  }, [error, intl])

  useEffect(() => {
    if (p && p === 'true') {
      onOpen()
      setInfoEdit(null)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [p])

  if (!data || loading) {
    return (
      <div>
        <div className='py-4 d-flex align-items-center justify-content-between'>
          <h2>{intl.formatMessage(M.title)}</h2>
          <Button className='d-flex align-items-center gap-2' disabled>
            <i className='bi bi-plus fs-2' style={{color: 'inherit'}} />
            {intl.formatMessage(M.add)}
          </Button>
        </div>
        <KTCard>
          <KTCardBody className='py-4'>
            <div
              className='d-flex align-items-center justify-content-center'
              style={{height: '40vh'}}
            >
              <Spinner animation='border' />
            </div>
          </KTCardBody>
        </KTCard>
      </div>
    )
  }

  return (
    <>
      <div>
        <div className='py-4 d-flex align-items-center justify-content-between flex-column flex-md-row gap-2'>
          <h2>{intl.formatMessage(M.title)}</h2>
          <Button
            className='d-flex align-items-center gap-2'
            onClick={() => {
              onOpen()
              setInfoEdit(null)
            }}
          >
            <i className='bi bi-plus fs-2' style={{color: 'inherit'}} />
            {intl.formatMessage(M.add)}
          </Button>
        </div>
        <KTCard>
          <KTCardBody className='py-4'>
            <div className='table-responsive'>
              <table
                id='kt_table_users'
                className='table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer'
              >
                <thead>
                  <tr className='text-start text-muted fw-bolder fs-7 text-uppercase gs-0'>
                    <th>{intl.formatMessage(M.thMember)}</th>
                    <th>{intl.formatMessage(M.role)}</th>
                    <th>{intl.formatMessage(M.email)}</th>
                    <th>{intl.formatMessage(M.phone)}</th>
                    <th />
                  </tr>
                </thead>
                <tbody className='text-gray-600 fw-bold'>
                  {data.allUsers.edges.map(({node}, i) => (
                    <tr key={node.id}>
                      <td
                        className={clsx({
                          'text-end min-w-100px': false /* cell.column.id === 'actions' */,
                        })}
                      >
                        <div className='d-flex align-items-center'>
                          {/* begin:: Avatar */}
                          <div className='symbol symbol-circle symbol-50px overflow-hidden me-3'>
                            <div
                              className={clsx(
                                'symbol-label fs-3 text-uppercase',
                                `bg-light-${getColorMember(i)}`,
                                `text-${getColorMember(i)}`
                              )}
                            >
                              {node.firstName?.charAt(0)}
                              {node.lastName?.charAt(0)}
                            </div>
                          </div>
                          <div className='d-flex flex-column'>
                            <a href='/#' className='text-gray-800 text-hover-primary mb-1'>
                              {node.lastName}
                            </a>
                            <span>{node.firstName}</span>
                          </div>
                        </div>
                      </td>
                      <th>{node.rol || intl.formatMessage(M.noRole)}</th>
                      <th>{node.email || NOT_RECORDED}</th>
                      <td>
                        <PhoneProviderActions phone={node.cellphone} />
                      </td>
                      <th>
                        <div>
                          <button
                            title={intl.formatMessage(M.edit)}
                            className='rounded-circle bg-transparent text-warning bg-warning-subtle border border-1'
                            onClick={() => {
                              setInfoEdit({
                                email: node.email,
                                id: node.id,
                                lastName: node.lastName,
                                name: node.firstName,
                                phone: node.cellphone,
                                rol: node.rol,
                              })
                              onOpen()
                            }}
                          >
                            <i className='bi bi-pencil' style={{color: 'inherit'}} />
                          </button>
                        </div>
                      </th>
                    </tr>
                  ))}
                  {data.allUsers.edges.length === 0 && (
                    <tr>
                      <td colSpan={6}>
                        <div className='d-flex text-center w-100 align-content-center justify-content-center'>
                          {intl.formatMessage(M.empty)}
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </KTCardBody>
        </KTCard>
      </div>

      {isOpen && (
        <ModalAddMember isOpen={isOpen} onClose={onClose} infoEdit={infoEdit} refetch={refetch} />
      )}
    </>
  )
}
